import { ExInput } from '@boomi/exosphere';
import type { DataAttributes } from '../types/dataAttributes';
import styles from './SearchInput.module.css';

interface SearchInputProps extends DataAttributes {
    value: string;
    placeholder?: string;
    onSearch: (value: string) => void;
    className?: string;
}

const SearchInput = ({
    value,
    placeholder = 'Search',
    onSearch,
    className,
    ...dataAttributes
}: SearchInputProps) => (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
        <ExInput
            type="search"
            leadingIcon="magnifying-glass"
            placeholder={placeholder}
            value={value}
            onInput={(e) => onSearch((e.target as HTMLInputElement).value)}
            clearable
            {...dataAttributes}
        />
    </div>
);

export default SearchInput;
